/**
 * kumpulan items pada input select
 */

"use strict";

function getValueItem(items, value) {
  const el = items.find(el => el.value === value)
  return el ? el.text : value
}

function getParentItemDivisi(item) {
  return itemsDivisi.find(el => el.value === item.parent)
}
function getListPPK() {
  return itemsDivisi.filter(el => el.is_ppk === 1)
}
function getPPKValue(val) {
  const el = itemsDivisi.find(el => el.value === val)
  return el.parent
}
function getPPKByDivisi(val) {
  const ele = itemsDivisi.find(el => el.value === val)

  return itemsDivisi.filter(el => el.value === ele.parent)
  
}

const tahunAnggaran = [
  {
    text: '2020',
    value: 2020
  },
  {
    text: '2021',
    value: 2021
  },
  {
    text: '2022',
    value: 2022
  },
  {
    text: '2023',
    value: 2023
  },
  {
    text: '2024',
    value: 2024
  },
  {
    text: '2025',
    value: 2025
  },
  {
    text: '2026',
    value: 2026
  },
  {
    text: '2027',
    value: 2027
  },
  {
    text: '2028',
    value: 2028
  },
  {
    text: '2029',
    value: 2029
  },
  {
    text: '2030',
    value: 2030
  },
  {
    text: '2031',
    value: 2031
  },
  {
    text: '2032',
    value: 2032
  },
  {
    text: '2033',
    value: 2033
  },
  {
    text: '2034',
    value: 2034
  },
  {
    text: '2035',
    value: 2035
  },
]

const provinsi2 = [
  {
    value:1,
    text:'Aceh'
  },
  {
    value:2,
    text:'Bali'
  },
  {
    value:3,
    text:'Banten'
  },
  {
    value:4,
    text:'Bengkulu'
  },
  {
    value:5,
    text:'DKI Yogyakarta'
  },
  {
    value:6,
    text:'DKI Jakarta'
  },
  {
    value:7,
    text:'Gorontalo'
  },
  {
    value:8,
    text:'Jambi'
  },
  {
    value:9,
    text:'Jawa Barat'
  },
  {
    value:10,
    text:'Jawa Tengah'
  },
  {
    value:11,
    text:'Jawa Timur'
  },
  {
    value:12,
    text:'Kalimantan Barat'
  },
  {
    value:13,
    text:'Kalimantan Selatan'
  },
  {
    value:14,
    text:'Kalimantan Tengah'
  },
  {
    value:15,
    text: 'Kalimantan Timur'
  },
  {
    value:16,
    text: 'Kalimantan Utara'
  },
  {
    value:17,
    text:'Kepulauan Bangka Belitung'
  },
  {
    value:18,
    text:'Kepulauan Riau'
  },
  {
    value:19,
    text:'Lampung'
  },
  {
    value:20,
    text:'Maluku'
  },
  {
    value:21,
    text:'Maluku Utara'
  },
  {
    value:22,
    text:'Nusa Tenggara Barat'
  },
  {
    value:23,
    text:'Nusa Tenggara Timur'
  },
  {
    value:24,
    text:'Papua'
  },
  {
    value:25,
    text:'Papua Barat'
  },
  {
    value:26,
    text:'Riau'
  },
  {
    value:27,
    text:'Sulawesi Barat'
  },
  {
    value:28,
    text:'Sulawesi Selatan'
  },
  {
    value:29,
    text:'Sulawesi Tengah'
  },
  {
    value:30,
    text:'Sulawesi Tenggara'
  },
  {
    value:31,
    text:'Sulawesi Utara'
  },
  {
    value:32,
    text:'Sumatra Barat'
  },
  {
    value:33,
    text:'Sumatra Selatan'
  },
  {
    value:34,
    text:'Sumatra Utara'
  }
]

const kabKota2 = [
  {
    value:1,
    text:'Kota Medan',
    prov:34
  },
  {
    value:2,
    text:'Kota Bandung',
    prov:9
  },
  {
    value:3,
    text:'Kota Banda Aceh',
    prov:1
  },
  {
    value:4,
    text:'Kabupaten Cianjur',
    prov:9
  },
  {
    value:5,
    text:'Jakarta Selatan',
    prov:6
  },
  {
    value:6,
    text:'Jakarta Utara',
    prov:6
  },
  {
    value:7,
    text:'Jakarta Barat',
    prov:6
  },
  {
    value:8,
    text:'Jakarta Pusat',
    prov:6
  }
]

const itemsPPKPengadaan = [
  {
    text: 'Direktur Utama',
    value: '10'
  },
  {
    text: 'Direktur Pengembangan',
    value: '20'
  },
  {
    text: 'Direktur Administrasi & Keuangan',
    value: '30'
  }
]

const itemsJenisIjiin = [
  {
    text: 'Surat Izin Usaha Perdagangan (SIUP)',
    value: 'SIUP',
    masa: 0
  },
  {
    text: 'Nomor Induk Berusaha (NIB)',
    value: 'NIB',
    masa: 0
  },
  // {
  //   text: 'Tanda Daftar Perusahaan (TDP)',
  //   value: 'TDP',
  //   masa: 5
  // },
  // {
  //   text: 'Pengusaha Kena Pajak (PKP)',
  //   value: 'PKP',
  //   masa: 0
  // },
  // {
  //   text: 'Surat Izin Usaha Jasa Konstruksi (SIUJK)',
  //   value: 'SIUJK',
  //   masa: 3
  // },
  {
    text: 'Sertifikat Badan Usaha (SBU)',
    value: 'SBU',
    masa: 3
  },
  // {
  //   text: 'Surat Izin Usaha Perusahaan Jasa Penilai (SIUPP)',
  //   value: 'SIUPP',
  //   masa: 5
  // },
  {
    text: 'Lainnya',
    value: 'LAINNYA',
    masa: 0
  },
]

const itemsKegiatanStatus = [
  {
    text: 'Baru',
    value: 'N'
  },
  {
    text: 'Paket',
    value: 'U'
  },
]

const itemsPaketStatus = [
  {
    text: 'Baru',
    value: 'N'
  },
  {
    text: 'Paket',
    value: 'U'
  },
]

const itemsUserStatus = [
  {
    text: 'Aktif',
    value: 'A'
  },
  {
    text: 'Non Aktif',
    value: 'I'
  },
  {
    text: 'Suspend',
    value: 'S'
  }
]

const itemsDivisi = [
  {
      text: "Direktur Utama",
      value: "10",
      parent: "",
      nick: "DIRUT",
      is_ppk: 1
  },
  {
      text: "Satuan Pengawasan Internal",
      value: "1010",
      parent: "10",
      nick: "SPI",
      is_ppk: 0
  },
  {
      text: "Divisi Sekrertaris Perusahaan",
      value: "1020",
      parent: "10",
      nick: "SEKPER",
      is_ppk: 0
  },
  {
      text: "Divisi Hukum Perusahaan",
      value: "1030",
      parent: "10",
      nick: "DIVHUPER",
      is_ppk: 0
  },
  {
      text: "SBU Novotel",
      value: "1040",
      parent: "10",
      nick: "SBUNOV",
      is_ppk: 0
  },
  {
      text: "SBU Apartemen",
      value: "1050",
      parent: "10",
      nick: "SBUAPT",
      is_ppk: 0
  },
  {
      text: "SBU Warna",
      value: "1060",
      parent: "10",
      nick: "SBUWARNA",
      is_ppk: 0
  },
  {
      text: "SBU Teknologi",
      value: "1070",
      parent: "10",
      nick: "UTIK",
      is_ppk: 0
  },
  {
      text: "Proyek Khusus(Likuidasi KSO NPK)",
      value: "1080",
      parent: "10",
      nick: "KSO",
      is_ppk: 0
  },
  {
      text: "PMO",
      value: "1090",
      parent: "10",
      nick: "PMO",
      is_ppk: 0
  },
  {
      text: "Direktur Pengembangan",
      value: "20",
      parent: "",
      nick: "DINGBAR",
      is_ppk: 1
  },
  {
      text: "Divisi Pengembangan Bisnis",
      value: "2010",
      parent: "20",
      nick: "DIVUS",
      is_ppk: 0
  },
  {
      text: "Divisi Pertanahan",
      value: "2020",
      parent: "20",
      nick: "DIVPH",
      is_ppk: 0
  },
  {
      text: "Divisi Perencanaan & Pembangunan",
      value: "2030",
      parent: "20",
      nick: "UPP",
      is_ppk: 0
  },
  {
      text: "Direktur Administrasi & Keuangan",
      value: "30",
      parent: "",
      nick: "DIRUTKEU",
      is_ppk: 1
  },
  {
      text: "Divisi Keuangan & Akuntansi",
      value: "3010",
      parent: "30",
      nick: "DIVKEU",
      is_ppk: 0
  },
  {
      text: "Divisi SDM, Umum, dan Aset",
      value: "3020",
      parent: "30",
      nick: "DIVUM",
      is_ppk: 0
  },
  {
      text: "Divisi Pengadaan",
      value: "3030",
      parent: "30",
      nick: "ULP",
      is_ppk: 0
  },
  {
      text: "Divisi Manajemen Risiko",
      value: "3040",
      parent: "30",
      nick: "UMRH",
      is_ppk: 0
  }
]

const itemsUserRoles = [
  {
    text: 'Admin Divisi / Unit',
    value: 'operator'
  },
  {
    text: 'Manajer Divisi / Unit',
    value: 'manajer'
  },
  {
    text: 'Admin ULP',
    value: 'operatorULP'
  },
  {
    text: 'Manajer ULP',
    value: 'manajerULP'
  },
  {
    text: 'Pejabat Pembuat Komitmen (PPK)',
    value: 'ppk'
  },
  // {
  //   text: 'Kuasa Pengguna Anggaran (KPA)',
  //   value: 'kpa'
  // },
  {
    text: 'Pengguna Anggaran (PA)',
    value: 'pa'
  },
  {
    text: 'Administrator IT',
    value: 'adminit'
  },
]

const statusDoc = [
  {
    status: 'N',
    caption: 'Belum diinput',
    color: 'red'
  },
  {
    status: 'V',
    caption: 'Menunggu Hasil Verifikasi',
    color: 'yellow darken-3'
  },
  {
    status: 'A',
    caption: 'Sudah Verifikasi',
    color: 'green',
  },
  {
    status: 'E',
    caption: 'Masa Berlaku Habis',
    color: 'lime',
  }
]

const statusVendor = [
  {
    status: 'N',
    caption: 'Persiapan Verifikasi',
    text: 'red--text',
    color: 'red'
  },
  {
    status: 'V',
    caption: 'Menunggu Hasil Verifikasi',
    text: 'yellow--text darken-3',
    color: 'yellow darken-3'
  },
  {
    status: 'A',
    caption: 'Aktif',
    text: 'green--text',
    color: 'green'
  },
  {
    status: 'I',
    caption: 'Non Aktif',
    text: 'pink--text',
    color: 'pink'
  },
  {
    status: 'S',
    caption: 'Suspend',
    text: 'orange--text',
    color: 'orange'
  },
  {
    status: 'E',
    caption: 'Masa Berlaku Habis',
    text: 'lime--text',
    color: 'lime'
  }
]

const itemsKbli = [
  {
    text: '4510 - Perdagangan mobil',
    value: '4510'
  },
  {
    text: '4530 - Perdagangan suku cadang dan aksesoris mobil',
    value: '4530'
  },
  {
    text: '4540 - Perdagangan, reparasi dan perawatan sepeda motor dan perdagangan suku cadang dan aksesorisnya',
    value: '4540'
  },
  {
    text: '4620 - Perdagangan besar hasil pertanian dan hewan hidup',
    value: '4620'
  },
  {
    text: '4631 - Perdagangan besar bahan makanan dan minuman hasil pertaninan',
    value: '4631'
  },
  {
    text: '4632 - Perdagangan besar bahan makanan dan minuman hasil peternakan dan perikanan',
    value: '4632'
  },
  {
    text: '4633 - Perdagangan suku cadang dan aksesoris mobil',
    value: '4633'
  },
  {
    text: '4530 - Perdagangan makanan dan minuman lainnya dan tembakau',
    value: '4530'
  },
  {
    text: '4641 - Perdagangan besar tekstil, pakaian dan alas kaki',
    value: '4641'
  },
  {
    text: '4642 - Perdagangan besar alat tulis dan hasil pencetakan dan penerbitan',
    value: '4642'
  },
  {
    text: '4643 - Perdagangan besar alat fotografi dan barang optik',
    value: '4643'
  },
  {
    text: '4649 - Perdagangan besar barang keperluan rumah tangga',
    value: '4649'
  },
  {
    text: '4651 - Perdagangan besar komputer, perlengkapan komputer dan piranti lunak',
    value: '4651'
  },
  {
    text: '4652 - Perdagangan besar pelengkapan elektronik dan telekomunikasi dan bagian-bagiannya',
    value: '4652'
  },
  {
    text: '4653 - Perdagangan besar mesin, peralatan dan perlengkapan pertanian',
    value: '4653'
  },
  {
    text: '4659 - Perdagangan besar mesin, peralatan dan perlengkapan lainnya',
    value: '4659'
  },
  {
    text: '4661 - Perdagangan besar bahan bakar padat, cair dan gas dan produk YBDI',
    value: '4661'
  },
  {
    text: '4662 - Perdagangan besar logam dan bijih logam',
    value: '4662'
  },
  {
    text: '4663 - Perdagangan besar bahan dan perlengkapan bangunan',
    value: '4663'
  },
  {
    text: '6202 - Aktivitas konsultasi komputer dan manajemen fasilitas komputer',
    value: '6202'
  },
  {
    text: '6811 - Real estat yang dimilik sendiri atau sewa',
    value: '6811'
  },
  {
    text: '7020 - Aktivitas konsultasi manajemen',
    value: '7020'
  },
  {
    text: '7310 - Periklanan',
    value: '7310'
  },
  {
    text: '7410 - Aktivitas perancangan khusus',
    value:  '7410'
  },
  {
    text: '7420 - Aktivitas fotografi',
    value: '7420'
  },
  {
    text: '7490 - Aktivitas profesional, ilmiah dan teknis lainnya',
    value: '7490'
  },
  {
    text: '7710 - Aktivitas penyewaan dan sewa guna usaha tanpa hak opsi atas mobil, bis, truk dan lainnya',
    value: '7710'
  },
  {
    text: '7730 - Aktivitas penyewaan dan sewa guna usaha usaha mesin, peralatan dan barang berwujud lainnya',
    value: '7730'
  },
  {
    text: '8121 - Aktivitas kebersihan umum dan bangunan',
    value: '8121'
  },
  {
    text: '8211 - Aktivitas penyedia gabungan jasa administrator kantor',
    value: '8211'
  }  
];

const itemsBentukUsaha = [
  {
    text: "Perusahaan Perseorangan",
    value: "pp"
  },
  {
    text: "Persekutuan Komanditer (CV)",
    value: "cv"
  },
  {
    text: "Persekutuan Firma",
    value: "fa"
  },
  {
    text: "Perseroan Terbatas (PT)",
    value: "pt"
  },
  {
    text: "Badan Usaha Milik Negara (BUMN)",
    value: "bumn"
  },
  {
    text: "Badan Usaha Milik Daerah (BUMD)",
    value: "bumd"
  },
  {
    text: "Koperasi",
    value: "koperasi"
  },
  {
    text: "Yayasan",
    value: "yayasan"
  } 
];

const itemsKualifikasi = [
  {
    text: "Perusahaan Mikro",
    value: "mikro",
  },
  {
    text: "Perusahaan Kecil",
    value: "kecil"
  },
  {
    text: "Perusahaan Menengah",
    value: "menengah"
  },
  {
    text: "Perusahaan Besar",
    value: "besar"
  } 
];

const itemsSatuanSaham = [
  {
    text: 'Lembar',
    value: 'L'
  },
  {
    text: 'Persen',
    value: 'P'
  }
]

/**
 * PROVINSI - KABUPATEN - KOTAMADYA
 */

const provinsi = [
  "Banten",
  "Jawa Barat",
  "DKI Jakarta",
  "Jawa Tengah",
  "DI Yogyakarta",
  "Jawa Timur",
  "Lampung"
];

const daerah = [
  {
    provinsi: "Banten",
    kabKota: [
      "Kabupaten Lebak",
      "Kabupaten Pandeglang",
      "Kabupaten Serang",
      "Kabupaten Tangerang",
      "Kota Cilegon",
      "Kota Serang",
      "Kota Tangerang",
      "Kota Tangerang Selatan"
    ]
  },
  {
    provinsi: "Jawa Barat",
    kabKota: [
      "Kabupaten Bandung",
      "Kabupaten Bandung Barat",
      "Kabupaten Bekasi",
      "Kabupaten Bogor",
      "Kabupaten Ciamis",
      "Kabupaten Cianjur",
      "Kabupaten Cirebon",
      "Kabupaten Garut",
      "Kabupaten Indramayu",
      "Kabupaten Karawang",
      "Kabupaten Kuningan",
      "Kabupaten Majalengka",
      "Kabupaten Pangandaran",
      "Kabupaten Purwakarta",
      "Kabupaten Subang",
      "Kabupaten Sukabumi",
      "Kabupaten Sumedang",
      "Kabupaten Tasikmalaya",
      "Kota Bandung",
      "Kota Banjar",
      "Kota Bekasi",
      "Kota Bogor",
      "Kota Cimahi",
      "Kota Cirebon",
      "Kota Depok",
      "Kota Sukabumi",
      "Kota Tasikmalaya"
    ]
  },
  {
    provinsi: "DKI Jakarta",
    kabKota: [
      "Kabupaten Administrasi Kepulauan Seribu",
      "Kota Administrasi Jakarta Barat",
      "Kota Administrasi Jakarta Pusat",
      "Kota Administrasi Jakarta Selatan",
      "Kota Administrasi Jakarta Timur",
      "Kota Administrasi Jakarta Utara"
    ]
  },
  {
    provinsi: "Jawa Tengah",
    kabKota: [
      "Kabupaten Banjarnegara",
      "Kabupaten Banyumas",
      "Kabupaten Batang",
      "Kabupaten Blora",
      "Kabupaten Boyolali",
      "Kabupaten Brebes",
      "Kabupaten Cilacap",
      "Kabupaten Demak",
      "Kabupaten Grobogan",
      "Kabupaten Jepara",
      "Kabupaten Karanganyar",
      "Kabupaten Kebumen",
      "Kabupaten Kendal",
      "Kabupaten Klaten",
      "Kabupaten Kudus",
      "Kabupaten Magelang",
      "Kabupaten Pati",
      "Kabupaten Pekalongan",
      "Kabupaten Pemalang",
      "Kabupaten Purbalingga",
      "Kabupaten Purworejo",
      "Kabupaten Rembang",
      "Kabupaten Semarang",
      "Kabupaten Sragen",
      "Kabupaten Sukoharjo",
      "Kabupaten Tegal",
      "Kabupaten Temanggung",
      "Kabupaten Wonogiri",
      "Kabupaten Wonosobo",
      "Kota Magelang",
      "Kota Pekalongan",
      "Kota Salatiga",
      "Kota Semarang",
      "Kota Surakarta",
      "Kota Tegal"
    ]
  },
  {
    provinsi: "DI Yogyakarta",
    kabKota: [
      "Kabupaten Bantul",
      "Kabupaten Gunungkidul",
      "Kabupaten Kulon Progo",
      "Kabupaten Sleman",
      "Kota Yogyakarta"
    ]
  },
  {
    provinsi: "Jawa Timur",
    kabKota: [
      "Kabupaten Bangkalan",
      "Kabupaten Banyuwangi",
      "Kabupaten Blitar",
      "Kabupaten Bojonegoro",
      "Kabupaten Bondowoso",
      "Kabupaten Gresik",
      "Kabupaten Jember",
      "Kabupaten Jombang",
      "Kabupaten Kediri",
      "Kabupaten Lamongan",
      "Kabupaten Lumajang",
      "Kabupaten Madiun",
      "Kabupaten Magetan",
      "Kabupaten Malang",
      "Kabupaten Mojokerto",
      "Kabupaten Nganjuk",
      "Kabupaten Ngawi",
      "Kabupaten Pacitan",
      "Kabupaten Pamekasan",
      "Kabupaten Pasuruan",
      "Kabupaten Ponorogo",
      "Kabupaten Probolinggo",
      "Kabupaten Sampang",
      "Kabupaten Sidoarjo",
      "Kabupaten Situbondo",
      "Kabupaten Sumenep",
      "Kabupaten Trenggalek",
      "Kabupaten Tuban",
      "Kabupaten Tulungagung",
      "Kota Batu",
      "Kota Blitar",
      "Kota Kediri",
      "Kota Madiun",
      "Kota Malang",
      "Kota Mojokerto",
      "Kota Pasuruan",
      "Kota Probolinggo",
      "Kota Surabaya"
    ]
  },
  {
    "provinsi": "Lampung",
    "kabKota": [
        "Kota Bandar Lampung",
        "Kota Metro",
        "Kabupaten Lampung Selatan",
        "Kabupaten Lampung Tengah",
        "Kabupaten Lampung Utara",
        "Kabupaten Lampung Timur",
        "Kabupaten Lampung Barat",
        "Kabupaten Tulang Bawang",
        "Kabupaten Tulang Bawang Barat",
        "Kabupaten Mesuji",
        "Kabupaten Tanggamus",
        "Kabupaten Way Kanan",
        "Kabupaten Pesawaran",
        "Kabupaten Pringsewu",
        "Kabupaten Pesisir Barat"
    ]
  }
];

const sumberDana = [
  {
    text: "PMD",
    value: "pmd"
  },
  {
    text: "Ekuitas",
    value: "ekuitas"
  }
];


// const jenisPengadaan = [
//   "Tender",
//   "Penunjukan Langsung"
// ];


// const metodePemilihan = [
//   "Swakelola",
//   "Tender"
// ];

// const itemsPemenang = [
//   { text: "1 Pemenang", value: '1' },
//   { text: "2 Pemenang", value: '2' },
//   { text: "3 Pemenang", value: '3' },
// ];

// const itemsUrutanMenang = [
//   { text: '1', value: 1 },
//   { text: '2', value: 2 },
//   { text: '3', value: 3 },
// ];


module.exports = { 
  getValueItem, getParentItemDivisi, getListPPK, getPPKValue, getPPKByDivisi,
  itemsKbli, itemsJenisIjiin, itemsBentukUsaha, provinsi, daerah, itemsKualifikasi, itemsSatuanSaham, itemsPaketStatus,
  statusVendor, statusDoc, itemsUserRoles, itemsDivisi, itemsUserStatus, itemsKegiatanStatus, provinsi2, kabKota2,
  sumberDana, tahunAnggaran, itemsPPKPengadaan,
  // jenisPengadaan, itemsPPK,
  // metodePemilihan,
  // itemsUrutanMenang
};
